import React, { useEffect } from "react";
import Api from "../../lib/componentApi";

const Unsubscribe = ({ onClosePopup, email, token }) => {
  const unsubscribe = () => {
    Api.post("/api/set/unsubscribe", { token }, (response, errors) => {
      if (errors) {
        console.log(response, errors);
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "code-unsubscribe");
      } else {
        if (response.status) {
          onClosePopup();
        }
      }
    });
  };

  const lessFrequent = () => {
    Api.post("/api/set/lessFrequent", { token }, (response, errors) => {
      if (errors) {
        console.log(response, errors);
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "code-less-frequent");
      } else {
        if (response.status) {
          onClosePopup();
        }
      }
    });
  };

  useEffect(() => {
    const popup = document.getElementById("popup-bg");

    if (popup) {
      popup.addEventListener("click", () => onClosePopup(), false);
    }
    return () =>
      popup.removeEventListener("click", () => onClosePopup(), false);
  }, []);
  return (
    <div className="email-verification">
      <div className="modal-bg-centered" id="popup-bg" />
      <div className="modal">
        {/* Header */}
        <div className="head-general with-back visible-xs">
          <a onClick={onClosePopup} className="back">
            <img src="/png/chevron-left.png" />
          </a>
          <h4>Unsubscribe</h4>
          <a className="close" />
        </div>
        {/* Header */}
        <div className="modal-body sticky-buttons">
          <div className="unsubscribe-page">
            <div className="white-bg mt-10px body">
              <h5>Sorry to see you go</h5>
              <div>
                <div
                  className="form-group sticky-form-label "
                  style={{ width: 300 }}
                >
                  <input
                    id="number"
                    style={{ backgroundColor: "white" }}
                    className="form-input active"
                    value={email}
                    disabled={true}
                  />
                  <label htmlFor="number">Your mail address</label>
                  <span></span>
                </div>
              </div>

              <div>
                <p>
                  If you would like to receive Local E mail offers, just not as
                  often, please select the <strong>"Less Frequent"</strong>{" "}
                  option below.
                </p>
                <div className="mt-1 btn-continue">
                  <button onClick={lessFrequent} className="btn btn-blue">
                    Less Frequent
                  </button>
                </div>
              </div>
              <div>
                <p>
                  If you would prefer not to receive any exclusive promotions
                  and special offers from Local E, please verify your email
                  address and click unsubscribe
                </p>
                <div className="mt-1 btn-continue">
                  <button
                    id="unsubscribe-button"
                    onClick={unsubscribe}
                    className="btn btn-blue"
                  >
                    Unsubscribe
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe;
